import { EventType } from '../domain/types';

export const eventTypeLabels: { [key in EventType]: string } = {
  [EventType.WHATSAPP]: 'WhatsApp',
};
